import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '@nibtravel/shared/ui/components/icon';
import { ModelsModule } from '@nibtravel/shared/util/models';

import { ErrorMessageComponent } from './error-message/error-message.component';
import { ValidationComponent } from './validation.component';
import { ValidationHandlerDirective } from './validation.directive';

@NgModule({
  imports: [CommonModule, IconModule, ModelsModule],
  declarations: [
    ErrorMessageComponent,
    ValidationHandlerDirective,
    ValidationComponent,
  ],
  exports: [
    ErrorMessageComponent,
    ValidationHandlerDirective,
    ValidationComponent,
  ],
})
export class ValidationModule {}
